/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_profile_statuserror1 = /** @type {(inputs: { message: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`프로필 로딩 오류: ${i?.message}`)
};

const en_profile_statuserror1 = /** @type {(inputs: { message: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error loading profile: ${i?.message}`)
};

const ja_profile_statuserror1 = /** @type {(inputs: { message: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロフィール読み込みエラー: ${i?.message}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ message: NonNullable<unknown> }} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const profile_statuserror1 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile_statuserror1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile_statuserror1", locale)
	if (locale === "ko") return ko_profile_statuserror1(inputs)
	if (locale === "en") return en_profile_statuserror1(inputs)
	return ja_profile_statuserror1(inputs)
};
export { profile_statuserror1 as "profile_statusError" }